import React from 'react'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
export const ProfileMenu = ({
    anchorElUser,
    handleCloseUserMenu,
    email,
    emailVerified,
    signout,
    signIn,
    handleOpenUserMenu
}) => {

    return (

        <>
            <Tooltip title="Open settings">

                <IconButton
                    className='setting-btn'
                    onClick={handleOpenUserMenu}
                    sx={{ p: 0 }}>

                    <img style={{ borderRadius: '100%' }} src="https://www.kindpng.com/picc/m/163-1636340_user-avatar-icon-avatar-transparent-user-icon-png.png" alt="" srcSet="" />
                </IconButton>
            </Tooltip>
            <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
            >
                <MenuItem
                    onClick={handleCloseUserMenu}
                >
                    <Link to='/my-orders' className='link' >My Orders</Link>
                </MenuItem>
                <MenuItem
                    onClick={handleCloseUserMenu}
                >
                    <Link to='/reviewList' className='link' >My List</Link>
                </MenuItem>
                {
                    email && emailVerified ? <MenuItem
                        onClick={handleCloseUserMenu}
                    >
                        <button className="btn text-dark p-0"
                            onClick={signout}
                        >Sign Out</button>
                    </MenuItem> :
                        <MenuItem
                            onClick={handleCloseUserMenu}
                        >
                            <button className="btn text-dark p-0"
                                onClick={signIn}
                            >Sign In</button>
                        </MenuItem>
                }
            </Menu>
        </>
    )
}
